import { render, staticRenderFns } from "./WorkerListAgeRangeAssignments.vue?vue&type=template&id=058a7ec1&"
import script from "./WorkerListAgeRangeAssignments.vue?vue&type=script&lang=js&"
export * from "./WorkerListAgeRangeAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports